export default __webpack_public_path__ + "images/53b408e0116a881e9471cf241f322b9c.png";